export default __webpack_public_path__ + "static/media/burdentobear.290796e8.png";